import { useEffect, useRef } from 'react';
import axios from 'axios';
import { KENO_API, gameHeaders } from './fairnessApi';

// Balance-only refresh: never replace an animating round, history or seed state.
export const useBalanceSync = ({ owner, demo, walletRef, apply, isBusy, poll = false }) => {
  const callbacks = useRef({ apply, isBusy });
  callbacks.current = { apply, isBusy };
  useEffect(() => {
    if (demo) return;
    const abort = new AbortController();
    let fetching = false;
    const update = (data, safeClaim = false) => {
      if (abort.signal.aborted || (!safeClaim && callbacks.current.isBusy()) || data.revision < walletRef.current.revision) return;
      callbacks.current.apply({ ...walletRef.current, balance_minor: data.balance_minor, vault_minor: data.vault_minor, revision: data.revision,
        ...(typeof data.ghost === 'boolean' ? { ghost: data.ghost } : {}) });
    };
    const refresh = async () => {
      if (fetching || callbacks.current.isBusy() || document.hidden) return;
      fetching = true;
      try { const { data } = await axios.get(`${KENO_API}/keno/wallet`, { headers: gameHeaders(false), signal: abort.signal }); update(data); } catch { /* Next balance refresh retries without interrupting a game. */ }
      finally { fetching = false; }
    };
    const notified = (event) => { if (event.detail?.user_id === owner) update(event.detail, event.detail.safe_claim_turn === true); else refresh(); };
    window.addEventListener('gv-wallet-updated', notified); window.addEventListener('focus', refresh);
    window.addEventListener('gv-privacy-updated', refresh);
    const timer = poll ? setInterval(refresh, 5000) : null;
    return () => { abort.abort(); if (timer) clearInterval(timer); window.removeEventListener('gv-wallet-updated', notified); window.removeEventListener('gv-privacy-updated', refresh); window.removeEventListener('focus', refresh); };
  }, [owner, demo, poll, walletRef]);
};